<script>
export const group = 'Bottom'
</script>

<script setup>
import TwoLineLowerThird from './shared/TwoLineLowerThird.vue'
const gsapTimeline = useGsapTimeline()

const props = defineProps({
  item: Object,
})

const line = computed(() => {
  const { traffic, speedtraps } = props.item.enrichment.trafficSummary
  return `${traffic.delay} minuten ${traffic.length}KM` + (speedtraps?.count > 0 ? ` // ${speedtraps.count} flitsers` : '')
})

const timeline = ref(null)
const timelineOut = ref(null)

onMounted(() => gsapTimeline({ name: 'TrafficSmall' }).add(timeline))

const { onDisappear } = useDisappearable()
onDisappear(async () => await gsapTimeline({ name: 'TrafficSmall - End' }).add(timelineOut.value()))
</script>

<template>
  <TwoLineLowerThird title="Verkeer" :line="line" @timeline="timeline = $event" @timelineOut="timelineOut = $event" />
</template>
